import { render, staticRenderFns } from "./SurgAdd.vue?vue&type=template&id=3b3bfc84"
import script from "./SurgAdd.vue?vue&type=script&lang=js"
export * from "./SurgAdd.vue?vue&type=script&lang=js"
import style0 from "./SurgAdd.vue?vue&type=style&index=0&id=3b3bfc84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports